<div class="row gap-4">
  <section class="col-12">

    <h3 class="title-text text-center h3-semibold">
      Check your email
    </h3>

    <p class="text-center h6-regular">
      We have sent a verification code to your email <b>{{email()}}</b>
    </p>

    <section class="col-12">
      <div class="form-floating">
        <input class="form-control" type="text" [(ngModel)]="code" placeholder="Enter code">
        <label>Enter code</label>
      </div>
    </section>

    <div class="d-grid col-12 mx-auto mt-3">
      <button type="button" class="btn btn-primary w-100" (click)="checkCode()">
        VERIFY CODE
      </button>
    </div>

    <div [routerLink]="['/login']" class="login__footer-action link-color">
      <span class="action-icon material-symbols-outlined">
        west
      </span>
      <span class="action-label">
        Back to login
      </span>
    </div>

  </section>

</div>